import gql from 'graphql-tag';

export default gql`
  mutation suspendCredential($channelId: UUID!, $mapId: String!) {
    suspendCredential(channelId: $channelId, mapId: $mapId)
  }
`;
